import { useEffect, useState } from 'react'

import { message } from 'antd'
import { motion, Variants } from 'framer-motion'

import { isSuccess } from '@/httpRequest'
import { getUserCheckIsFollowed } from '@/httpRequest/modules/people/userCheckIsFollowed'
import { putIMFollow } from '@/httpRequest/modules/user/imFollow'
import { useUserAtom } from '@/store/user'
import { handleClickFollow } from '@/utils/trackSensors'

import styles from './index.module.less'
import { useMessageAtom } from '../../store/message'
import { EConversationType } from '../../types/message'

const FolloweTip = () => {
  const { currentConversation } = useMessageAtom()
  const [isFollowed, setIsFollowed] = useState(true)
  const { user, updateUser } = useUserAtom()
  const variants: Variants = {
    hidden: { display: 'none' },
    visible: {}
  }

  const handleFollowAdd = async (user_id: string) => {
    handleClickFollow(user.id, user_id, '2')
    const resp = await putIMFollow({ user_id })

    if (isSuccess(resp)) {
      message.success('success')
      setIsFollowed(true)
      updateUser({ ...user, following: user.following + 1 })
    }
  }

  const handleGetUserCheckIsFollowed = async (user_id: string) => {
    const resp = await getUserCheckIsFollowed({ user_id })

    if (isSuccess(resp)) {
      setIsFollowed(resp.data.is_followed)
    }
  }

  useEffect(() => {
    if (currentConversation?.session_type === EConversationType.PRIVATE) {
      handleGetUserCheckIsFollowed(currentConversation?.session_id)
    }
  }, [currentConversation?.session_id])

  return (
    <motion.div
      className={`${styles.followBox}`}
      initial="visible"
      animate={isFollowed ? 'hidden' : 'visible'}
      variants={variants}
      transition={{ duration: 0.6 }}
    >
      <span>Follow each other as friends</span>
      <button
        className={`g-btn g-btn-primary`}
        onClick={() => {
          handleFollowAdd(currentConversation?.session_id || '')
        }}
      >
        Follow
      </button>
    </motion.div>
  )
}

export default FolloweTip
